import { useBnbSelector } from "../../redux/store";
import { useBnbOptionalLabel } from "../../utils/labels";

type ETAType = {
    show: boolean;
    loading: boolean; // if a loader should be shown
    date: string | false;
    disclaimer: string | null;
};

const useETA = (): ETAType => {
    const eta = useBnbSelector((state) => state.eta);
    const settings = useBnbSelector((state) => state.bnbSettings);
    const disclaimer = useBnbOptionalLabel("etaDisclaimer");

    const show = settings.showETA && !eta.error;
    const loading = !eta.error && ((!eta.loaded && !eta.loading) || eta.loading);

    return {
        show,
        loading,
        date: eta.date,
        disclaimer,
    };
};

export default useETA;
